import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from './ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center px-6 pt-20">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-12 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-16 h-16 text-green-600" />
            </div>
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Payment Successful!
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            Thank you for your purchase. Your payment has been processed successfully.
          </p>
          
          {orderId && (
            <div className="bg-blue-50 rounded-lg p-6 mb-8">
              <p className="text-sm text-gray-600 mb-2">Order ID</p>
              <p className="text-lg font-mono font-semibold text-blue-600">{orderId}</p>
            </div>
          )}
          
          <div className="space-y-4">
            <p className="text-gray-700">
              A confirmation email has been sent to your email address with the order details.
            </p>
            <p className="text-gray-700">
              Our team will contact you shortly to discuss your project requirements and next steps.
            </p>
          </div>
          
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-8 py-3 rounded-full text-lg"
            >
              Back to Home
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => navigate('/contact')}
              variant="outline"
              className="px-8 py-3 rounded-full text-lg border-2 border-blue-600 text-blue-600 hover:bg-blue-50"
            >
              Contact Us
            </Button>
          </div>
          
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Need help? Contact us at{' '}
              <a href="mailto:admin@codecommerce.co" className="text-blue-600 hover:underline">
                admin@codecommerce.co
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
